import addPromotionalQtyToValue from './addPromotionalQtyToValue'

export interface ICalculateNewQuantity {
  originalValue: number
  minQtyAllowed: number
  promotionalQty: number
  inRangeValue: number
  autoAdd: boolean
  freegoodsAsSubitem: boolean
  jumpQty: number | string
  resultFixed: boolean
  resultValue: number
  minQty: number | null
}

export const recalculateValueFromInput = ({
  originalValue,
  minQtyAllowed,
  inRangeValue,
  jumpQty,
  autoAdd,
  freegoodsAsSubitem,
  promotionalQty,
  resultFixed,
  resultValue,
  minQty,
}: ICalculateNewQuantity): number => {
  if (resultFixed) {
    return resultValue
  }

  if (
    originalValue !== minQtyAllowed &&
    typeof minQty === 'number' &&
    minQty > originalValue
  ) {
    return minQty
  }

  if (typeof jumpQty === 'number' && jumpQty > 1) {
    const updatedOriginalValue = addPromotionalQtyToValue({
      valueToUpdate: originalValue,
      promotionalQty,
      freegoodsAsSubitem,
      autoAdd,
    })

    const quantityWithoutMin = updatedOriginalValue - minQtyAllowed
    const module = quantityWithoutMin % jumpQty
    const adjustedQuantity =
      module > 0 ? updatedOriginalValue - module : updatedOriginalValue
    const finalAdjustedQuantity =
      adjustedQuantity < minQtyAllowed ? minQtyAllowed : adjustedQuantity

    return finalAdjustedQuantity
  }
  return inRangeValue
}

export default recalculateValueFromInput
